export default __webpack_public_path__ + "static/media/modal3.28611836.png";